<template>
    <div></div>
</template>

<script>
import BlankBaseTemplate from "@/layouts/BlankBaseTemplate.vue";

export default {
    mixins: [BlankBaseTemplate],
    data() {
        return {
            nextRoute: null
        }
    },
    mounted: function () {
        const that = this;
        that.$store
            .dispatch("user/getUser")
            .then(() => {
                // add conditional push
                if (this.nextRoute.query.next === "/dashboard/structure-count-report") {
                    that.$router.push({ name: "structure-count-report" });
                } else {
                    that.$router.push({ name: "dashboard" });
                }
            })
            .catch(() => {
                that.$store.commit("clearAuthorizationToken");
                that.showLoginDialog();
            });
    },
    beforeRouteLeave(to, from, next) {
        this.hideLoginDialog();
        next();
    },
    // get next rounte, i.e., destination
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.nextRoute = to;
        })
    },
};
</script>
